<template>
    <div>
        <v-row
            class="justify-center  align-center my-16"
            v-if="!$store.state.user"
        >
            記録を登録/表示するには、ログインが必要です
        </v-row>
        <v-row class="justify-center  align-center mt-12">
            <v-select
                v-model="selected_tag"
                :items="$store.state.tags"
                label="曲のタグを選択"
                clearable
                class="shrink"
            ></v-select>
        </v-row>
        <v-row class="justify-center  align-center mt-12">
            <v-data-table
                :headers="headers"
                :items="items"
            >
                <template v-slot:item.score="{ item }">
                    <v-chip
                        :color="getColor(item.score)"
                        dark
                    >
                        {{ item.score }}
                    </v-chip>
                </template>
                <template v-slot:item.play="{ item }">
                    <audio controls>
                        <source :src="'https://devpsa2161052-dev.s3-ap-northeast-1.amazonaws.com/public/' + $store.state.username + '/' + item.file_id + '.mp3'">
                    </audio>
                </template>
                <template v-slot:item.actions="{ item }">

                    <v-icon
                        small
                        @click="openDialog(2); selected_item = item"
                    >
                        mdi-delete
                    </v-icon>

                    <v-btn
                        v-show="item.ranking==0"
                        class="ma-2"
                        x-small
                        color="primary"
                        dark
                        @click="openDialog(1); selected_item = item"
                    >
                        非公開
                    </v-btn>
                    <v-btn
                        v-show="item.ranking==1"
                        class="ma-2"
                        x-small
                        color="red"
                        dark
                        @click="openDialog(1); selected_item = item"
                    >
                        公開中
                    </v-btn>

                </template>
            </v-data-table>
        </v-row>
        <v-dialog v-model="dialog" max-width="400">
            <v-card>
                <v-card-title>
                <div v-if="dialog_state==1">ランキング公開</div>
                <div v-if="dialog_state==2">削除</div>
                </v-card-title>
                <v-card-text>
                    <p v-if="dialog_state==1">ファイル{{ selected_item.file_name }}を<span v-if="selected_item.ranking==0">公開</span><span v-if="selected_item.ranking==1">非公開に</span>しますか？</p>
                    <p v-if="dialog_state==2">ファイル{{ selected_item.file_name }}を削除しますか？</p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="closeDialog">閉じる</v-btn>
                    <v-btn @click="action(selected_item)">確認</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from 'axios';
export default {
    name: "RecordComponent",
    data(){
        return {
            selected_tag: null,
            items: [],
            headers: [
                {
                    text: "ファイル名",
                    value: "file_name"
                },
                {
                    text:"Score",
                    value: "score"
                },
                {
                    text:"アップ日",
                    value: "up_date"
                },
                {
                    text:'再生',
                    value:'play',
                    sortable:false
                },
                {   text: 'Actions',
                    value: 'actions',
                    sortable: false
                },
            ],
            dialog: false,
            dialog_state: 0,
            selected_item: []
        }
    },
    watch:{
        selected_tag:function(newVal) {
            this.items = [];
            const apiUrl = "https://flhrsaddm1.execute-api.ap-northeast-1.amazonaws.com/dev/getrecord";
            // apiへの送信情報を定義
            const post_data = { 
                username : this.$store.state.username,
                tag : newVal
            };
            const headers = {
                headers: {
                    "Content-Type": "application/json"
                }
            } 
            // POST送信
            const _this = this;
            axios.post(apiUrl,post_data,headers)
            .then((res) => {
                _this.items = res.data.Items;
            })
            .catch((err) => {
                console.log(err);
            })            
        }
    },
    methods:{
        deleteItem(selected_item){
            const apiUrl = "https://flhrsaddm1.execute-api.ap-northeast-1.amazonaws.com/dev/deleterecord";
            // apiへの送信情報を定義
            const post_data = { 
                username : this.$store.state.username,
                file_id: selected_item.file_id,
                up_date: selected_item.up_date
            };
            const headers = {
                headers: {
                    "Content-Type": "application/json"
                }
            } 
            // POST送信
            const _this = this;
            axios.post(apiUrl,post_data,headers)
            .then(() => {
                _this.items = _this.items.filter((item)=> {
                    return item.file_id != selected_item.file_id
                })
            })
            .catch((err) => {
                console.log(err);
            })
            this.dialog = false;
        },
        getColor (score) {
            if (score > 90) return 'red'
            else if (score > 80) return 'orange'
            else return 'green'
        },
        closeDialog(){
            this.dialog = false;
        },
        openDialog(code){
            this.dialog = true;
            if (code === 1){
                this.dialog_state = 1;
            }else if (code === 2){
                this.dialog_state = 2;
            }else{
                return;
            }
        },
        updateRanking(item){
            const apiUrl = "https://flhrsaddm1.execute-api.ap-northeast-1.amazonaws.com/dev/updateranking"
            // apiへの送信情報を定義
            const post_data = { 
                user : item.user,
                up_date: item.up_date,
                ranking: item.ranking
            };
            const headers = {
                headers: {
                    "Content-Type": "application/json"
                }
            } 
            // POST送信
            axios.post(apiUrl,post_data,headers)
            .then(() => {
                item.ranking = !item.ranking;
            })
            .catch((err) => {
                console.log(err);
            })
            this.dialog = false;
        },
        action(item){
            if(this.dialog_state === 1){
                this.updateRanking(item);
            }else if(this.dialog_state === 2){
                this.deleteItem(item);
            }else{
                return
            }
        }
    }
};

</script>